import { Injectable, signal } from "@angular/core";
import { ApplicationMessageResponse, Client } from "src/domain/client";

@Injectable({
  providedIn: "root"
})
export class ApplicationMessageService {
  applicationMessages = signal<ApplicationMessageResponse[]>([]);

  constructor() {}

  getApplicationMessages(): void {
    new Client()
      .apiV2ASWPActiveApplicationMessages()
      .then((applicationMessages) => {
        this.applicationMessages.set(applicationMessages ?? []);
      })
      .catch((error) => {
        console.error("ApplicationMessages error:", error);
      });
  }

  deleteApplicationMessage(id: number): void {
    this.applicationMessages.update((messages) =>
      messages.filter((_) => _.applicationMessageId !== id)
    );
  }
}
